import { render, staticRenderFns } from "./CompanyEditModuleMetaDataApiKeys.vue?vue&type=template&id=06814f6e&"
import script from "./CompanyEditModuleMetaDataApiKeys.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditModuleMetaDataApiKeys.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06814f6e')) {
      api.createRecord('06814f6e', component.options)
    } else {
      api.reload('06814f6e', component.options)
    }
    module.hot.accept("./CompanyEditModuleMetaDataApiKeys.vue?vue&type=template&id=06814f6e&", function () {
      api.rerender('06814f6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditModuleMetaDataApiKeys.vue"
export default component.exports